import React from 'react';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@rocco/components/popover';
import { AVAILABLE_REACTIONS } from '../../utils';

/**
 * A reaction picker popover that allows users to react to a message with an
 * emoji. Pass a child component to be the popover trigger.
 */
export function ReactionPicker({
    children,
    open,
    onOpenChange,
    onReact,
}: {
    children: React.ReactNode;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onReact?: (reaction: string) => void;
}) {
    return (
        <Popover open={open} onOpenChange={onOpenChange}>
            {children && <PopoverTrigger asChild>{children}</PopoverTrigger>}
            <PopoverContent
                className="flex items-center gap-[2px] overflow-hidden rounded-[8px] p-[6px]"
                side="top"
                align="center"
            >
                {AVAILABLE_REACTIONS.map((emoji) => (
                    <button
                        key={emoji}
                        type="button"
                        className="p-[4px] text-[18px] leading-none transition-transform hover:scale-125"
                        onClick={() => {
                            onOpenChange(false);
                            onReact?.(emoji);
                        }}
                        aria-label={`React with ${emoji}`}
                    >
                        {emoji}
                    </button>
                ))}
            </PopoverContent>
        </Popover>
    );
}
